module.exports = __webpack_public_path__ + "static/img/logo.dc038a04.png";